import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { adminLoginUser } from "core/redux/features/auth/adminLoginSlice";
const AdminLogin = () => {
  const navigate = useNavigate();
  const route = all_routes;
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ email: "", password: "" });
  const [toggle, setToggle] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = { email: "", password: "" };
    let hasError = false;
    if (!email.trim()) {
      newErrors.email = "Email is required";
      hasError = true;
    }
    if (!password.trim()) {
      newErrors.password = "Password is required";
      hasError = true;
    }
    setErrors(newErrors);
    if (hasError) return;
    const user = await dispatch(adminLoginUser({ email, password }));
    if (user?.payload?.success) {
      localStorage.setItem("_id", user?.payload?.user?._id);
      localStorage.setItem("token", user?.payload?.token);
      localStorage.setItem("roles", user?.payload?.roles);
      localStorage.setItem("first_name", user?.payload?.user?.first_name);
      localStorage.setItem("last_name", user?.payload?.user?.last_name);
      toast.success(user?.payload?.message);
      navigate("/admin/admin-dashboard");
    } else {
      toast.error(user?.payload?.message || "something went wrong");
    }
  };
  return (
    <div className="main-wrapper">
      <div className="login-content">
        <div className="row">
          <div className="col-md-6 login-bg d-none d-lg-flex">
            <div className="mx-auto">
              <div className="login-carousel-section mb-3">
                <div className="login-banner">
                  <ImageWithBasePath
                    src="assets/img/auth/auth-1.svg"
                    className="img-fluid"
                    alt="Logo"
                  />
                </div>
                <div className="mentor-course text-center">
                  <h3 className="mb-2">
                    Welcome to{" "}
                    <span className="text-secondary">AIATI in India. </span>{" "}
                    Courses.
                  </h3>
                  <p>
                    A trusted platform to manage, deliver, and track aviation
                    learning .
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 login-wrap-bg">
            <div className="login-wrapper">
              <div className="loginbox">
                <div className="w-100">
                  <div
                    className="d-flex align-items-center justify-content-between mb-3"
                    style={{ height: "70px" }}
                  >
                    <img
                      src="/assets/img/logo/AviationLogo-08.png"
                      alt="Logo"
                      height="70"
                      style={{ height: "70px" }}
                    />
                  </div>
                  <h1 className="fs-32 fw-bold topic">
                    Admin/Instructor Login
                  </h1>

                  <form onSubmit={handleSubmit} className="mb-3 pb-3">
                    <div className="mb-3 position-relative">
                      <label className="form-label">
                        Email<span className="text-danger ms-1">*</span>
                      </label>
                      <div className="position-relative">
                        <input
                          type="email"
                          className={`form-control form-control-lg ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          placeholder="Enter your email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                        <span>
                          <i className="isax isax-sms input-icon text-gray-7 fs-14" />
                        </span>
                        {errors.email && (
                          <div className="text-danger mt-1">{errors.email}</div>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 position-relative">
                      <label className="form-label">
                        Password <span className="text-danger ms-1">*</span>
                      </label>
                      <div className="position-relative" id="passwordInput">
                        <input
                          type={toggle ? "text" : "password"}
                          className={`form-control form-control-lg pass-input ${
                            errors.password ? "is-invalid" : ""
                          }`}
                          placeholder="Enter your password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <span
                          onClick={() => setToggle(!toggle)}
                          className="isax toggle-passwords fs-14 isax-eye-slash"
                        ></span>
                        {errors.password && (
                          <div className="text-danger mt-1">
                            {errors.password}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-between mb-4">
                      <div className="remember-me d-flex align-items-center"></div>
                      <div>
                        <Link to={route.forgotpassword} className="link-2">
                          Forgot Password ?
                        </Link>
                      </div>
                    </div>
                    <div className="d-grid">
                      <button
                        className="btn btn-secondary btn-lg"
                        type="submit"
                      >
                        Login
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
